import { setupUnhandled, loadSardine, CustomMonitor } from '@jdd/sgm-monitor';

setupUnhandled();
export async function beforeMount() {
  const isProduction = process.env.JL_ENV === 'production';
  CustomMonitor.disabled = !isProduction;
  const key = !isProduction ? 'test' : 'prod';
  await loadSardine(`jl/jltk-m/${key}`);
}
